export default {
  noticeList: [],
  noticeDetail: {},
  srchParam: {},
};
